import React from 'react'

const Exclamation = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/exclamation',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <g
        transform='translate(8.778 4)'
        fill={primaryColor}
        fillRule='nonzero'
      >
        <path d='M1.972 6.833V.75a.75.75 0 0 0-1.5 0v6.083a.75.75 0 0 0 1.5 0z' />
        <circle cx={1.272} cy={9.8} r={1} />
      </g>
      <path
        d='M10 18c-4.414 0-8-3.586-8-8s3.586-8 8-8 8 3.586 8 8-3.586 8-8 8z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
    </g>
  </svg>
)

export default Exclamation
